import { gql } from '@apollo/client'

export const GET_COUNTRIES = gql`
  query {
    countries {
      isoCode
      name
    }
  }
`

export const GET_STATES = gql`
  query States($countryIsoCode: String!) {
    states(countryIsoCode: $countryIsoCode) {
      isoCode
      name
    }
  }
`
